import { gitBusinessActivityCourier, gitBusinessActivityRemovals, gitBusinessActivityVehicleTransportation, gitBusinessActivityVehicleTransportationAndRemovals } from '../../localeConstants';
import { getLocalTranslation } from '../i18nKit';
export var getGitBusinessActivityDescriptionText = function getGitBusinessActivityDescriptionText(businessActivity, config) {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  var descText = '';

  if ([gitBusinessActivityCourier].includes(businessActivity)) {
    var prefix = (config === null || config === void 0 ? void 0 : config.displayType) === 'edit' ? $t('longStatement:git_courier_edit_desc') : $t('longStatement:git_courier_info_desc');
    descText = prefix;
  } else if ([gitBusinessActivityRemovals].includes(businessActivity)) {
    descText = $t('longStatement:git_removals_desc');
  } else if ([gitBusinessActivityVehicleTransportation].includes(businessActivity)) {
    descText = $t('longStatement:git_vehicle_transportation_desc');
  } else if ([gitBusinessActivityVehicleTransportationAndRemovals].includes(businessActivity)) {
    descText = $t('longStatement:git_vehicle_transportation_removals_desc');
  }

  return descText;
};